<div class="app-container">

  <app-header></app-header>

  <div class="side-menu-and-main">
    <app-sidemenu></app-sidemenu>
    <main>

      <app-page-banner></app-page-banner>

      <div class="main-container">
        <router-outlet></router-outlet>
      </div>

      <app-footer></app-footer>

    </main>
  </div>

</div>
